var _dec, _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { observes } from '@ember-decorators/object';
import Helper from '@ember/component/helper';
import { subunitsLabel } from '@dashboard/junk-drawer/utils/subunits';
let UnitsLabel = (_dec = observes('units.@each.nickname'), _class = class UnitsLabel extends Helper {
  // eslint-disable-next-line ember/no-observers
  onUnitsChange() {
    this.recompute();
  }
  compute([units, totalUnitsCount]) {
    this.set('units', units);
    const nicknames = units.map(unit => unit.nickname);
    return subunitsLabel(nicknames, totalUnitsCount);
  }
}, _applyDecoratedDescriptor(_class.prototype, "onUnitsChange", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "onUnitsChange"), _class.prototype), _class);
export { UnitsLabel as default };